var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoPoint({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.22107 9.06387C0.384519 7.70279 -0.0760434 6.25487 0.010312 4.64464C0.085094 3.24582 0.768815 1.89363 1.83802 1.03268C2.90722 0.172335 4.34322 -0.181743 5.67268 0.0894916C7.09116 0.378522 8.35088 1.38584 9.00018 2.71838C9.64918 1.38584 10.9089 0.378522 12.3277 0.0894916C13.6568 -0.181743 15.0934 0.172335 16.1623 1.03298C17.2315 1.89363 17.915 3.24613 17.9897 4.64495C18.0758 6.25518 17.6155 7.70309 16.779 9.06387C15.6638 10.8778 12.2666 14.5153 8.99988 16C5.73292 14.5153 2.33568 10.8781 1.22077 9.06387",
    fill: "url(#paint0_linear_2405_1864)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.22107 9.06387C0.384519 7.70279 -0.0760434 6.25487 0.010312 4.64464C0.085094 3.24582 0.768815 1.89363 1.83802 1.03268C2.90722 0.172335 4.34322 -0.181743 5.67268 0.0894916C7.09116 0.378522 8.35088 1.38584 9.00018 2.71838C9.64918 1.38584 10.9089 0.378522 12.3277 0.0894916C13.6568 -0.181743 15.0934 0.172335 16.1623 1.03298C17.2315 1.89363 17.915 3.24613 17.9897 4.64495C18.0758 6.25518 17.6155 7.70309 16.779 9.06387C15.6638 10.8778 12.2666 14.5153 8.99988 16C5.73292 14.5153 2.33568 10.8781 1.22077 9.06387",
    fill: "url(#paint1_linear_2405_1864)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9791 7.06874C12.9268 6.90675 12.7831 6.79169 12.6131 6.77637L10.3041 6.56671L9.39104 4.42963C9.32372 4.27301 9.17039 4.17163 9.00004 4.17163C8.82969 4.17163 8.67636 4.27301 8.60904 4.43L7.69599 6.56671L5.38661 6.77637C5.21692 6.79206 5.07361 6.90675 5.02093 7.06874C4.96826 7.23073 5.01691 7.40841 5.14527 7.52041L6.89061 9.05109L6.37595 11.3182C6.33829 11.4849 6.40299 11.6572 6.5413 11.7572C6.61564 11.8109 6.70262 11.8382 6.79033 11.8382C6.86595 11.8382 6.94097 11.8178 7.00829 11.7775L9.00004 10.5871L10.9911 11.7775C11.1368 11.8652 11.3204 11.8572 11.4584 11.7572C11.5968 11.6569 11.6614 11.4845 11.6238 11.3182L11.1091 9.05109L12.8544 7.52072C12.9828 7.40841 13.0318 7.23104 12.9791 7.06874Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2405_1864",
    x1: 8.6914,
    y1: 15.9997,
    x2: 8.6914,
    y2: -0.0782172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F16722"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB8856"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2405_1864",
    x1: 8.6914,
    y1: 16,
    x2: 7.86749,
    y2: -0.00461884,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F16722"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.737487,
    stopColor: "#FFB18E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE9D6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoPoint);
export default __webpack_public_path__ + "static/media/ico-point.0b2f05268ab800740c8989f7050aeb0c.svg";
export { ForwardRef as ReactComponent };